
import {css} from '@emotion/react'
import { PhotoWithIndex } from "type"
import { MouseEvent} from "react"
import { PHOTO_LIST_RESOURCE_URL} from 'config'
import { BiSolidMoviePlay } from 'react-icons/bi'
import { IconContext } from 'react-icons'

type Props = {
  photo: PhotoWithIndex
  isSelected: boolean
  order?: number
  onClick?: (event: MouseEvent<HTMLDivElement>, index: number)=>void
}

export const SelectVideoItem = (props: Props) =>{
  const filenameWithoutExtention = props.photo.filename.split('.')[0]

  const onRawClick = (event: MouseEvent<HTMLDivElement>) =>{
    event.stopPropagation()
    if (props.onClick === undefined) return

    props.onClick(event, props.photo.index)
  }

  return(
    <div onClick={onRawClick}>
      <img
        loading="lazy"
        css={imgCss}
        src={PHOTO_LIST_RESOURCE_URL+'/'+filenameWithoutExtention+'.0000000.jpg'}
        alt="uploaded"
      />
      <div css={iconCss}>
        <IconContext.Provider value={{color: "#fff", size:"1.3rem"}}>
          <BiSolidMoviePlay/>
        </IconContext.Provider>
      </div>
      {props.isSelected && (
        <div css={overWrapCss}>
          <div>
            {props.order}
          </div>
        </div>
      )}
    </div>
  )
}

const imgCss = css`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`
const iconCss=css`
  position: absolute;
  bottom: 5px;
  right: 5px;
`

const overWrapCss=css`
  display: flex;
  top: 1rem;
  right: 1rem;
  width: 3rem;
  height: 3rem;
  border-radius: 100%;
  position: absolute;
  z-index: 100;
  background-color: dodgerblue;
  font-size: 1.5rem;
  color: white;
  justify-content: center;
  align-items: center;
`